import api from './axios';

// Get ticket volume trends
export const getTicketVolumeTrends = async (params = {}) => {
  const response = await api.get('/reports/volume-trends', { params });
  return response.data;
};

// Get total tickets count only (fallback when volume-trends fails)
export const getTotalTicketsReport = async () => {
  const response = await api.get('/reports/total-tickets');
  return response.data;
};

// Get response time analytics
export const getResponseTimeAnalytics = async (params = {}) => {
  const response = await api.get('/reports/response-times', { params });
  return response.data;
};

// Get resolution time reports
export const getResolutionTimeReports = async (params = {}) => {
  const response = await api.get('/reports/resolution-times', { params });
  return response.data;
};

// Get agent performance metrics
export const getAgentPerformanceMetrics = async (params = {}) => {
  const response = await api.get('/reports/agent-performance', { params });
  return response.data;
};

// Get company-wise analysis
export const getCompanyWiseAnalysis = async (params = {}) => {
  const response = await api.get('/reports/company-analysis', { params });
  return response.data;
};

// Get comprehensive reports
export const getComprehensiveReports = async (params = {}) => {
  const response = await api.get('/reports/comprehensive', { params });
  return response.data;
};

